import { InboxMenuItem } from "./inbox-models";

export const GenerateInboxSubTitleMenuItem = (title: string) => {
  return {
    menuItemType: "SUB_TITLE",
    label: title,
  } as InboxMenuItem;
};
